<template>
  <div v-if="!isLoading" class="columns is-multiline">
    <div class="column is-one-fifth" v-for="product in products" :key="product.id">
      <div class="card">
        <div class="card-image has-padding-md has-text-centered">
          <img :src="product.logo" :alt="product.name">
        </div>
        <div class="card-content has-text-centered">
          <p class="title is-5">{{ product.name }}</p>
        </div>
        <footer class="card-footer">
          <router-link :to="{ name: 'products-edit', params: { product: product.id } }"
            class="card-footer-item has-text-primary">
            <span class="icon"><i class="fas fa-edit"></i></span>
            <span v-t="'buttons.edit'" />
          </router-link>

          <a href=""
            @click.prevent="destroy($event, product.id)"
            type="button" class="card-footer-item has-text-danger">
            <span class="icon"><i class="fas fa-times"></i></span>
            <span v-t="'buttons.remove'" />
          </a>
        </footer>
      </div>
    </div>
  </div>
  <loading-content v-else />
</template>

<script>
import API from '@/api'
import Utils from '@/utils'
import LoadingContent from './LoadingContent'

export default {
  name: 'ProductsIndex',
  components: { LoadingContent },
  data () {
    return {
      isLoading: true,
      products: {}
    }
  },
  mounted () {
    this.fetchAll()
  },
  methods: {
    // Busca por todos os usuários já cadastrados no sistema.
    fetchAll () {
      this.isLoading = true
      API.products.index({ take: -1 }, products => {
        this.isLoading = false
        this.products = products
      })
    },

    // Remove o usuário com base em sua ID
    destroy (event, id) {
      let card = event.target.closest('.card')
      let name = this.products.find(x => x.id === id).name

      Utils.alertConfirmation(
        this.$t('delete_alert', { name }),
        toast => {
          API.products.destroy(id, () => {
            this.$snotify.remove(toast.id)
            card.style.background = '#ff0'
            Utils.fadeOut(card, 630, () => card.closest('.column').remove())
          })
        },
        toast => this.$snotify.remove(toast.id),
        this.$snotify
      )
    }
  },
  watch: {
    // Atualiza a listagem sempre que não for uma rota de cadastro/edição.
    '$route' ({ name }) {
      if (name === 'products') {
        this.fetchAll()
      }
    }
  }
}
</script>

<i18n>
{
  "en-US": {
    "buttons": {
      "edit": "Edit",
      "remove": "Remove"
    },
    "delete_alert": "Are you sure you want to remove product {name}?"
  },
  "pt-BR": {
    "buttons": {
      "edit": "Editar",
      "remove": "Remover"
    },
    "delete_alert": "Tem certeza que deseja remover o produto {name}?"
  }
}
</i18n>
